import "./src/styles/main.css"

// or:
// require('./src/styles/global.css')